export default __webpack_public_path__ + "static/media/GertvandeKolk.51fbfe83.jpg";